var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"logo-tile",class:{ 'fixed':_vm.fixed },attrs:{"to":_vm.route,"tag":"div"}},[_c('img',{attrs:{"src":require("../assets/MB_Monogram_White_RGB.png"),"alt":"Matt Barnes logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }